export default "__VITE_ASSET__scg3ODsC__"